// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__b6CbS","android12Modal":"modal_android12Modal__NH98x","android12Enter":"modal_android12Enter__10H6V"};